import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as dialogPopupActions from '../../actions/dialogPopupActions';

class Preloader extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {

        };

    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    componentDidUpdate() {

    }



    render() {
        return (
            <div className="pl-circle">
                <div className="pl-circle1 pl-child" />
                <div className="pl-circle2 pl-child" />
                <div className="pl-circle3 pl-child" />
                <div className="pl-circle4 pl-child" />
                <div className="pl-circle5 pl-child" />
                <div className="pl-circle6 pl-child" />
                <div className="pl-circle7 pl-child" />
                <div className="pl-circle8 pl-child" />
                <div className="pl-circle9 pl-child" />
                <div className="pl-circle10 pl-child" />
                <div className="pl-circle11 pl-child" />
                <div className="pl-circle12 pl-child" />
            </div>
        );
    }
}

Preloader.propTypes = {
    initData: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

Preloader.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        initData: state.initData,
        contentData: state.contentData,
        trackingData: state.trackingData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Preloader);



/** WEBPACK FOOTER **
 ** ./src/components/initialisation/Preloader.js
 **/